<template>
    <div>
        <modal v-model:show="modal" body-classes="p-0">
            <card class="mb-0" header-classes="p-0 rounded-top" footer-classes="d-flex align-items-center justify-content-end">
                <template #header><div class="py-4 px-3" :style="$bgColor(color.primary)">
                    <h6 
                        class="modal-title" 
                        id="modal-title-default"
                        :style="{color: color.secondary}"
                    >{{$t('exercise.time.title')}} </h6>
                </div></template>
                <template v-if="true">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                        <i class="mdi mdi-av-timer" style="font-size: 5em"></i>
                        <p class="text-center">{{$t('exercise.time.description')}}.</p>
                        <p class="text-center" :style="{color: color.primary}">{{$t('exercise.time.rules')}}.</p>
                    </div>
                </template>
                <template #footer>
                    <base-button 
                        type="primary" 
                        :style="$bgColor(color.primary)"
                        @click="getStudentTime"
                    >{{$t('common.start')}}</base-button>
                </template>
            </card>
        </modal>
    </div>
</template>

<script>

import Card from '../../argon/components/Cards/Card'
import Modal from '../../argon/components/Modal'
import BaseButton from '../../argon/components/BaseButton'

export default {
    name: 'ExerciseTimerConfirmation',
    components: {
        Card,
        Modal,
        BaseButton
    },
    data() {
        return {
            modal: false
        }
    },
    watch: {
        exercise: {
            handler(newVal) {
                if (newVal.time && !newVal.finished && !newVal.started) {
                    return this.showModal()
                }
            },
            immediate: true,    
            deep: true
        }
    },
    computed: {
        exercise() {
            return this.$store.getters.LOADED_EXERCISE
        },
        color() {
            return this.$store.getters.COLOR
        }
    },
    methods: {
        showModal() {
            setTimeout(() => this.modal = true, 100)
        },
        async getStudentTime() {
            await this.$store.dispatch('GET_EXERCISE_STUDENT_TIME')
            this.modal = false
        }
    }
}
</script>

<style>

</style>